import user_module from '@/modules/user/index';

import VueRouter, { RouteConfig } from 'vue-router';

import Home from '@/views/Home.vue';
import PageUsermenu from '@/views/PageUsermenu.vue';
import PageLogin from '@/views/PageLogin.vue';
import PageRestore from '@/views/PageRestore.vue';
import PageRegister from '@/views/PageRegister.vue';
import PageNotFound from '@/views/PageNotFound.vue';
import PageSSO from '@/views/PageSSO.vue';

import PageError from '@/views/PageError.vue';

import PageTrial from '@/views/PageTrial.vue';
import PageTrialLogout from '@/views/PageTrialLogout.vue';

import PageTrialResult from '@/views/PageTrialResult.vue';
import PageRegisterSuccess from '@/views/PageRegisterSuccess.vue';
import PageSwagger from '@/views/PageSwagger.vue';
import PageThankyou from '@/views/PageThankyou.vue';

import LLEXE from '@/landings/LEXE/index.vue';
import NewLexe from '@/landings/LE_NEW/index.vue';
import pctvideo from '@/landings/pctvideo/index.vue';
import LPP from '@/landings/PP/index.vue';
import LRBO from '@/landings/RBO/index.vue';
import LFK from '@/landings/FK/index.vue';
import LIRA from '@/landings/IRA/index.vue'
import LPCT2 from "@/landings/PCT2/index.vue";
import REMAI from "@/components/remai/index.vue";
import LPCT from "@/landings/PCT/index.vue";
import LPOW from '@/landings/POW/index.vue';
import LCRM from '@/landings/CRM/index.vue';
import LFS from '@/landings/FS/index.vue';
import LCO from '@/landings/CO/index.vue';
import LPDF from '@/landings/PDF/index.vue';
import Article from '@/components/article/index.vue';
import DATAPAGE from '@/landings/DATAPAGE/index.vue';
import Refresh from '@/components/refresh/index.vue';


// import IframeArticle from '@/components/iframe-article/index.vue';
// import Events from '@/components/events/index.vue';
import About from '@/components/about/index.vue';
import Investingcounterpoint from '@/components/investingcounterpoint/index.vue'; 
import Video from '@/components/video/index.vue';
import Faq from '@/components/faq/index.vue';
// import LPS from '@/landings/PS/index.vue';
import Requestdemo from '@/request-demo/index.vue'

import Riskchallenge from '@/components/riskchallenge/index.vue';
import history_module from "@/modules/history";


const routes: RouteConfig[] = [
  { 
    path: "/refresh", 
    name: 'refresh',
    component: Refresh
  },
  { 
    path: "/data", 
    name: 'data',
    component: DATAPAGE ,    
    meta: {
      product: 'datapage',
      landing: true
    }
  },

  {
    path: "/larkspurexecutive/landingpage", 
    name: 'errorl',
    component: LLEXE,
    meta: {
      product: 'lexe',
      landing: true
    }
  },
  {
    path: "/larkspurexecutive/landing", 
    name: 'landings_regbioptimizer',
    component: LLEXE,
    meta: {
      product: 'lexe',
      landing: true
    }
  },
  {
    path: "/regbioptimizer/index",
    name: "landings_regbioptimizer",
    component: LRBO,
    meta: {
      product: 'rbo',
      landing: true
    }
  },
  { 
    path: "*", 
    name: '404',
    component: PageNotFound 
  },
  { 
    path: "/sso", 
    name: 'sso',
    component: PageSSO 
  },
  { 
    path: "/pctvideo", 
    name: 'pctvideo',
    component: pctvideo 
  },
  { 
    path: "/sandbox/sso", 
    name: 'sso',
    component: PageSSO 
  },
  { 
    path: "/riskchallenge", 
    name: 'riskchallenge',
    component: Riskchallenge 
  },
  // { 
  //   path: "/events", 
  //   name: 'events',
  //   component: Events 
  // },
  {
    path: "/error", 
    name: 'error',
    component: PageError 
  },

  { 
    path: "/about", 
    name: 'about',
    component: About ,
    meta: { gtm: 'About' }

  },
  { 
    path: "/investing_counterpoint", 
    name: 'investingcounterpoint',
    component: Investingcounterpoint ,
    meta: { gtm: 'Investingcounterpoint' }

  },
  { 
    path: "/new-lexe", 
    name: 'newLexe',
    component: NewLexe ,
    meta: { gtm: 'NewLexe' }

  },
  { 
    path: "/video_guide", 
    name: 'video_guide',
    component: Video ,
    meta: { gtm: 'Video' }

  },
  { 
    path: "/faq", 
    name: 'faq',
    component: Faq 
  },
  {
    path: "/",
    name: "home",
    component: Home,
    meta: { gtm: 'Home' }
  },
  {
    path: "/login",
    name: "login",
    component: PageLogin,
  },
  {
    path: '/restore',
    name: 'Restore',
    component: PageRestore
  },
  {
    path: '/register',
    name: 'Register',
    component: PageRegister
  },
  {
    path: '/swagger',
    name: 'Swagger',
    component: PageSwagger
  },
  {
    path: '/thankyou',
    name: 'thankyou',
    component: PageThankyou,
    meta: { gtm: 'Home' }
  },
  {
    path: '/register-success',
    name: 'RegisterSuccess',
    component: PageRegisterSuccess
  },
  {
    path: '/trial',
    name: 'Trial',
    component: PageTrial
  },
  {
    path: '/trial_logout',
    name: 'TrialLogout',
    component: PageTrialLogout
  },
  {
    path: '/trial_result',
    name: 'TrialResult',
    component: PageTrialResult
  },
  {
    path: "/usermenu",
    name: "usermenu",
    props: route => ({ id: route.query.id }),
    component: PageUsermenu,
    meta: { gtm: 'Usermenu' }
  },
  {
    path: "/larkspurexecutive/:id(.*)",
    name: "lexe",
    props: {
      iframe: true, 
      site: "larkspurexecutive", 
      id: "lexe"
    },
    meta: {
      iframe: true
    },
  },

  {
    path: "/campaigns/:id(.*)",
    name: "cmp",
    props: {
      iframe: true, 
      mvp: true,
      site: "campaigns", 
      id: "cmp"
    },
    meta: {
      iframe: true
    },
  },

  {
    path: "/coinoptimizer/:id(.*)",
    name: "co",
    props: {
      iframe: true, 
      site: "coinoptimizer", 
      id: "co"
    },
    meta: {
      iframe: true
    },
  },
  {
    path: "/pctpro",
    name: "pctpro",
    props: {
      iframe: true,
      site: "pctpro",
      id: "pctpro",
      single: true
    },
    meta: {
      iframe: true
    },
  }, 

  {
    path: "/fundscreener/:id(.*)",
    name: "fs",
    props: {
      iframe: true, 
      site: "fundscreener",
      mvp: true,
      id: "fs"
    },
    meta: {
      iframe: true
    },
  },

  {
    path: "/pctnew/:id(.*)",
    name: "pctnew",
    props: {
      iframe: true, 
      site: "pctnew",
      mvp: true,
      id: "pctnew"
    },
    meta: {
      iframe: true
    },
  },

  {
    path: "/remai/:id(.*)",
    name: "remai",
    props: {
      iframe: true, 
      site: "remai",
      mvp: true,
      id: "remai"
    },
    meta: {
      iframe: true
    },
  },
  
  {
    path: "/pdfparser/:id(.*)",
    name: "pdf",
    props: {
      iframe: true, 
      site: "pdfparser",
      mvp: true,
      id: "pdf"
    },
    meta: {
      iframe: true
    },
  },

  {
    path: "/regbioptimizer/:id(.*)",
    name: "rbo",
    props: {
      iframe: true, 
      site: "regbioptimizer", 
      id: "rbo"
    },
    meta: {
      iframe: true
    },
  },

  {
    path: "/401k/:id(.*)",
    name: "401k",
    props: {
      iframe: true,
      site: "401k",
      id: "401k"
    },
    meta: {
      iframe: true
    },
  },
  {
    path: "/planisphere/:id(.*)",
    name: "ps",
    props: {
      iframe: true,
      site: "planisphere",
      id: "ps"
    },
    meta: {
      iframe: true
    },
  },
  {
    path: "/crm/:id(.*)",
    name: "crm",
    props: {
      iframe: true,
      site: "crm",
      id: "crm",
      mvp: true
    },
    meta: {
      iframe: true
    },
  },
  {
    path: "/irafiduciaryoptimizer/:id(.*)",
    name: "ira",
    props: {
      iframe: true,
      site: "irafiduciaryoptimizer",
      id: "ira"
    },
    meta: {
      iframe: true
    },
  },
  {
    path: "/pow/:id(.*)",
    name: "pow",
    props: {
      iframe: true,
      site: "pow",
      id: "pow"
    },
    meta: {
      iframe: true
    },
  },
  {
    path: "/landings_crm",
    name: "landings_crm",
    component: LCRM,
    meta: {
      product: 'crm',
      landing: true
    }
  },
  {
    path: "/landings_larkspurexecutive",
    name: "landings_larkspurexecutive",
    component: LLEXE,
    meta: {
      product: 'lexe',
      landing: true
    }
  },
  {
    path: "/landings_proplus",
    name: "landings_proplus",
    component: LPP,
    meta: {
      product: 'proplus',
      landing: true
    }
  },
  {
    path: "/proplus",
    name: "landings_proplus",
    component: LPP,
    meta: {
      product: 'proplus',
      landing: true
    }
  },
  {
    path: "/landings_regbioptimizer",
    name: "landings_regbioptimizer",
    component: LRBO,
    meta: {
      product: 'rbo',
      landing: true
    }
  },
  {
    path: "/landings_401k",
    name: "landings_401k",
    component: LFK,
    meta: {
      product: '401k',
      landing: true
    }
  },
  {
    path: "/landings_ira",
    name: "landings_ira",
    component: LIRA,
    meta: {
      product: 'ira',
      landing: true
    }
  },
  {
    path: "/landings_pctpro",
    name: "landings_pctpro",
    component: LPCT,
    meta: {
      product: 'pctpro',
      landing: true
    }
  },
  {
    path: "/remai",
    name: "remai",
    component: REMAI,
    meta: {
      product: 'remai',
      landing: true,
      iframe: true
    }
  },
  {
    path: "/pct",
    name: "pct",
    component: LPCT2,
    meta: {
      product: 'pctpro',
      landing: true
    }
  },
  {
    path: "/landings_pow",
    name: "landings_pow",
    component: LPOW,
    meta: {
      product: 'pow',
      landing: true
    }
  },
  {
    path: "/landings_fundscreener",
    name: "landings_fundscreener",
    component: LFS,
    meta: {
      product: 'fs',
      landing: true
    }
  },
  {
    path: "/landings_pdfparser",
    name: "landings_pdfparser",
    component: LPDF,
    meta: {
      product: 'pdf',
      landing: true
    }
  },
  {
    path: "/landings_coinoptimizer",
    name: "landings_coinoptimizer",
    component: LCO,
    meta: {
      product: 'co',
      landing: true
    }
  },
  {
    path: "/landings_planisphere",
    name: "landings_planisphere",
    component: LLEXE,
    meta: {
      product: 'ps',
      landing: true
    }
  },

  {
    path: "/requestdemo/:id",
    name: "requestdemo",
    meta: {
      iframe: true,
      exception: true
    },
    component: Requestdemo
  },
  
  {
    path: "/requestdemo_ira",
    name: "requestdemo_ira",
    props: {
      src: "ira/requestdemo", 
      iframe: true,
      exception: true
    },
    meta: {
      iframe: true
    },
    component: Requestdemo
  },
  {
    path: "/pctpro/requestdemo",
    name: "/pctpro/requestdemo",
    props: {
      src: "requestdemo?product=PCT&source=rixtremacom", 
      iframe: true
    },
    meta: {
      iframe: true
    },
    component: Requestdemo
  },
  {
    path: "/requestdemo_ps",
    name: "requestdemo_ps",
    meta: {
      iframe: true
    },
    component: Requestdemo,
  },
  {
    path: "/article",
    name: "article",
    component: Article,
    props: route => ({ id: route.query.id }),
  },
  {
    path: "/compliancereport/:id(.*)",
    name: "ap",
    props: {
      iframe: true,
      site: "compliancereport",
      id: "ap",
      mvp: true
    },
    meta: {
      iframe: true
    },
  },

  
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior: () => ({ x: 0, y: 0 })
});

router.beforeEach(async (to, from, next) => {

  console.log('from', from);

  if (from.path !== '/usermenu'){

    history_module.setPrev(from.fullPath);

  }

  if (to.path === '/404') {
    next()
  }

  if (user_module.token){

    if (to.path === '/login'){

      next('/');

    } else {

      next();
      
    }

  } else {

    next()

  }

})

router.afterEach(async (to) => {

  window.dataLayer = window.dataLayer || []; 

  window.dataLayer.push({   
  'event': 'Pageview',
  'pagePath': to.path,
  'pageTitle': to.name
  }); 
})



export default router;
